import { create } from '@/shared/utils/zustandVue'

import {
  type ApplicationConfig,
  ApplicationConfigService,
} from '../service/applicationConfig.service'
import { ErrorService } from '../service/errorService'

class AppConfigState {
  appConfig?: ApplicationConfig
}

type AppConfigStore = AppConfigState & {
  setAppConfig: (appConfig: ApplicationConfig) => void
  loadAppConfig: () => Promise<void>
  markDirty: () => Promise<void>
}

/**
 * App-config store — idiomatic zustand-vue.
 *
 * Holds the `ApplicationConfig` document fetched from the backend. Actions
 * load it (`loadAppConfig`) and mark it dirty (`markDirty`); the `SET_APP_CONFIG`
 * mutation is now the `setAppConfig` action. Getters (`featureIsEnable`,
 * `getTimezone`, `isDirty`, `getRemotionUrl`) are inlined as computeds in
 * consumers via `useAppConfigStore`.
 */
export const useAppConfigStore = create<AppConfigStore>((set) => ({
  ...new AppConfigState(),
  setAppConfig: (appConfig) => {
    set({ appConfig })
  },
  loadAppConfig: async () => {
    try {
      set({ appConfig: await ApplicationConfigService.get() })
    } catch (e) {
      ErrorService.handleError(e, false)
    }
  },
  markDirty: async () => {
    try {
      const applicationCfg = await ApplicationConfigService.markDirty()
      set({ appConfig: applicationCfg })
    } catch (e) {
      ErrorService.handleError(e)
    }
  },
}))
